(function () {
  if (window.__pfContactWidgetInit) return;
  window.__pfContactWidgetInit = true;

  var ENDPOINT = 'https://contact-form.pluginfox.workers.dev/api/contact';
  var SUPPORT_EMAIL = 'support@pluginfox.com';
  var FIXED_SUBJECT = 'Website contact widget';

  function init() {
    var toggle = document.getElementById('pf-contact-toggle');
    var panel = document.getElementById('pf-contact-panel');
    var closeBtn = document.getElementById('pf-contact-close');
    var form = document.getElementById('pf-contact-form');
    var submitBtn = document.getElementById('pf-contact-submit');
    var msgEl = document.getElementById('pf-contact-msg');
    if (!toggle || !panel || !form) return;

    function openPanel() {
      panel.classList.add('pf-contact-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      var first = form.querySelector('input[name="name"]');
      if (first) first.focus();
    }
    function closePanel() {
      panel.classList.remove('pf-contact-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      // After a successful send, reopening shows a fresh form that can be sent again.
      if (form.hidden) {
        form.hidden = false;
        form.dataset.submitting = 'false';
        setMessage('', null);
      }
    }
    toggle.addEventListener('click', function () {
      if (panel.classList.contains('pf-contact-open')) closePanel(); else openPanel();
    });
    closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('pf-contact-open')) closePanel();
    });

    function setMessage(content, type) {
      msgEl.textContent = '';
      msgEl.className = type ? 'pf-contact-' + type : '';
      if (!content) return;
      if (typeof content === 'string') msgEl.textContent = content;
      else msgEl.appendChild(content);
    }

    function mailtoFallback() {
      var wrap = document.createElement('span');
      wrap.appendChild(document.createTextNode('Something went wrong. Please email us directly at '));
      var link = document.createElement('a');
      link.href = 'mailto:' + SUPPORT_EMAIL;
      link.textContent = SUPPORT_EMAIL;
      wrap.appendChild(link);
      wrap.appendChild(document.createTextNode(' instead.'));
      return wrap;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending...';
      setMessage('', null);

      var data = new FormData(form);
      var submissionId = form.dataset.submissionId || crypto.randomUUID();
      form.dataset.submissionId = submissionId;
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          submissionId: submissionId,
          name: data.get('name') || '',
          email: data.get('email') || '',
          subject: FIXED_SUBJECT,
          message: data.get('message') || '',
          website: data.get('website') || '',
          order: data.get('order') || '',
        }),
      })
        .then(function (res) {
          if (res.ok) return res.json().then(function () { return { success: true }; });
          if (res.status >= 400 && res.status < 500) {
            return res.json().catch(function () {
            return { error: res.status === 429 ? 'Too many messages. Please wait and try again later.' : 'Please check your details and try again.' };
          }).then(function (data) { return { success: false, message: data.error, conflict: data.code === 'submission_conflict' }; });
          }
          return Promise.reject();
        })
        .then(function (result) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send';
          if (result.success) {
            form.reset();
            delete form.dataset.submissionId;
            form.hidden = true;
            setMessage('Thanks -- we got your message and will get back to you by email soon.', 'success');
          } else {
            form.dataset.submitting = 'false';
            if (result.conflict) delete form.dataset.submissionId;
            setMessage(result.message || 'Please check your details and try again.', 'error');
          }
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Send';
          form.dataset.submitting = 'false';
          setMessage(mailtoFallback(), 'error');
        });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();